import React from 'react';
import {connect} from 'react-redux';
import ChargesAndDiscount from './ChargesAndDiscount';

const ChargesAndDiscountBlock = ({data, context, programDiscounts, additionalCharges, family}) => {
  let chargesAndDiscountComponent = <div></div>;
  switch (family) {
    case 'C':
      if(additionalCharges && additionalCharges.charges.length != 0)
        {chargesAndDiscountComponent = (
          <ChargesAndDiscount data={data} context={context} programDiscounts={programDiscounts} additionalCharges={additionalCharges} />
        );}
      break;

    default:
      break;
  }
  return chargesAndDiscountComponent;
};

const mapStateToProps = (state) => {
  return {
    programDiscounts: state.cellcomTransactionSummary.transactionData.programDiscounts,
    additionalCharges: state.cellcomTransactionSummary.transactionData.additionalCharges,
    family: state.cellcomTransactionSummary.transactionData.generalDetails.family,
  };
};
export default connect(mapStateToProps, null)(ChargesAndDiscountBlock);
